import { useCallback, useEffect, useState } from 'react'

export const useDevice = () => {
  const [hasCamera, setHasCamera] = useState(false)

  const getCameraInfo = useCallback(async () => {
    const hasCamera = await navigator.mediaDevices
      .enumerateDevices()
      .then((infos) => [...infos].some((info) => info.kind === 'videoinput'))
    setHasCamera(hasCamera)
  }, [])

  useEffect(() => {
    getCameraInfo()
  }, [getCameraInfo])

  return {
    hasCamera,
  }
}
